import { useEffect, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { HexColorPicker, HexColorInput } from "react-colorful";

export type Theme = {
	primaryColor: string;
	headerImageUrl?: string;
};

export default function Home() {
	const [primaryColor, setPrimaryColor] = useState("#aabbcc");
	const [enableImage, setEnableImage] = useState(false);
	const [headerImageUrl, setHeaderImageUrl] = useState<string | undefined>(undefined);

	async function fetchThemeData() {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/theme`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		});

		if (!res.ok) {
			const data = await res.json();
			console.error(data.message);
			throw new Error(data.message);
		}

		const data: Theme = await res.json();

		setPrimaryColor(data.primaryColor);
		setHeaderImageUrl(data.headerImageUrl);
		setEnableImage(!!data.headerImageUrl);
	}

	async function saveThemeData() {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/theme`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ primaryColor, headerImageUrl }),
		});

		const data = await res.json();

		if (!res.ok) {
			console.error(data.message);
			throw new Error(data.message);
		}
	}

	useEffect(() => {
		fetchThemeData();
	}, []);

	async function onFileChange(e: React.ChangeEvent<HTMLInputElement>) {
		const file = e.target.files?.[0];
		if (!file) return;
		console.log(file);

		const res = await fetch(`${process.env.REACT_APP_API_URL}/presignedUrl`);
		const data = await res.json();

		const signedUrl = data.signedUrl;
		const imageUrl = data.imageUrl;

		await fetch(signedUrl, {
			method: 'PUT',
			body: file,
		});

		setHeaderImageUrl(imageUrl);
	}

	return (
		<div className="Home">
			<div className='container container-lg'>
				<h1>Theme</h1>
				<div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
					<Form.Group controlId="primaryColor" className="mb-3">
						<Form.Label>Primary Color</Form.Label>
						<HexColorPicker color={primaryColor} onChange={setPrimaryColor} />
						<InputGroup className="mb-3" style={{ width: "auto" }}>
							<InputGroup.Text id="basic-addon1">#</InputGroup.Text>
							<Form.Control
								as={HexColorInput}
								color={primaryColor}
								onChange={setPrimaryColor as any}
							/>
						</InputGroup>
					</Form.Group>
					<Form.Group controlId="image" className="mb-3" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
						<Form.Label>Header Image</Form.Label>
						<Form.Check
							type={'checkbox'}
							label={`Include Image?`}
							checked={enableImage}
							onChange={(e) => setEnableImage(e.target.checked)}
						/>
						{enableImage && <img width={400} src={headerImageUrl} alt="" />}
						{enableImage && <Form.Control type="file" onChange={onFileChange} />}
					</Form.Group>
				</div>
				<Button onClick={() => { saveThemeData() }} >Save</Button>
			</div>
		</div>
	);
}
